import { t } from '@lingui/macro'
import { Text, View } from '@react-pdf/renderer'
import { getLabelFromTranslationData } from 'app/views/common/translationsCommon'
import { formPDFStyles } from 'app/views/forms/pdf-components/FormPdf'
import FormPdfFillArea from 'app/views/forms/pdf-components/FormPdfFillArea'
import { pdfDefaultFontSize } from 'app/views/forms/pdf-components/PDFCommon'
import { myI18n } from 'translation/I18nConnectedProvider'
import { getCensusGeoData } from './censusGeoDataLoader'

const styles = {
  text: {
    fontSize: pdfDefaultFontSize,
    marginLeft: 8
  },
  question: {
    fontSize: pdfDefaultFontSize,
    marginTop: 8,
    marginBottom: 8
  },
  description: {
    fontSize: pdfDefaultFontSize - 2,
    fontStyle: 'italic',
    marginTop: 4,
    marginBottom: 4
  },
  required: {
    fontSize: pdfDefaultFontSize - 2,
    fontStyle: 'italic',
    marginLeft: 4,
    marginTop: 4
  },
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 4
  },
  listItem: {
    flexDirection: 'row',
    marginBottom: 4,
    width: '48%',
    flexWrap: 'nowrap'
  },
  odd: {
    marginLeft: '4%'
  }
}

export const FormCensusDivisionFillablePdf = ({
  value,
  elementType,
  typeProps,
  langVersion,
  title,
  helpText,
  tooltip,
  altLabelPlacement,
  ...props
}) => {
  const provinceLabels = getCensusGeoData().caProvinces.features.map(province => {
    if (langVersion === 'iu-cans') {
      if (province.properties.nameIU) {
        return province.properties.nameIU
      } else {
        return getLabelFromTranslationData({
          data: { portalTranslationId: province.properties.name }
        })
      }
    } else if (langVersion === 'en') {
      return province.properties.name
    } else if (langVersion === 'fr') {
      return province.properties.nom
    }
    return province.properties.name
  })

  return (
    <View>
      <View wrap={false}>
        <Text style={styles.question}>
          {myI18n._(t`CENZUS_DIVISION_ELEMENT_SCOPE`)}
          {` (${myI18n._(t`Required`)})`}
        </Text>

        <View style={styles.row}>
          <View style={formPDFStyles.radioCheck} />
          <Text style={styles.text}>
            {myI18n._(t`CENZUS_DIVISION_ELEMENT_SCOPE_NEIGHBOURHOOD_OPTION`)}
          </Text>
        </View>
        <View style={styles.row}>
          <View style={formPDFStyles.radioCheck} />
          <Text style={styles.text}>
            {myI18n._(t`CENZUS_DIVISION_ELEMENT_SCOPE_MUNCIPAL_OPTION`)}
          </Text>
        </View>
        <View style={styles.row}>
          <View style={formPDFStyles.radioCheck} />
          <Text style={styles.text}>
            {myI18n._(t`CENZUS_DIVISION_ELEMENT_SCOPE_REGIONAL_OPTION`)}
          </Text>
        </View>
        <View style={styles.row}>
          <View style={formPDFStyles.radioCheck} />
          <Text style={styles.text}>
            {myI18n._(
              t`CENZUS_DIVISION_ELEMENT_SCOPE_PROVINCE_OR_TERRITORY_OPTION`
            )}
          </Text>
        </View>
      </View>

      <View wrap={false}>
        <Text style={styles.question}>
          {myI18n._(t`CENZUS_DIVISION_ELEMENT_PROVINCE_OR_TERRITORY_QUESTION`)}
          {` (${myI18n._(t`Required`)})`}
        </Text>
        <View style={styles.row}>
          {provinceLabels.map((province, index) => {
            const isOdd = index % 2 === 1
            const _styles = isOdd
              ? [styles.listItem, styles.odd]
              : [styles.listItem]
            return (
              <View style={_styles} key={index} wrap={false}>
                <View style={formPDFStyles.radioCheck} />
                <Text style={styles.text}>
                  {province}
                </Text>
              </View>
            )
          })}
        </View>
      </View>

      <View wrap={false}>
        <Text style={styles.question}>
          {myI18n._(t`FORM_CENZUS_DIVISION_PDF_CENSUS_DIVISION_MUNICIPAL`)}
          {` (${myI18n._(t`Required`)})`}
        </Text>

        <View style={styles.row}>
          <FormPdfFillArea lines={1} />
        </View>
      </View>

      <View wrap={false}>
        <Text style={styles.question}>
          {myI18n._(t`FORM_CENZUS_DIVISION_PDF_CENSUS_DIVISION_REGIONAL`)}
          {` (${myI18n._(t`Required`)})`}
        </Text>

        <View style={styles.row}>
          <FormPdfFillArea lines={1} />
        </View>
      </View>
    </View>
  )
}
